import React from "react";
import { useLanguage } from "../context/LanguageContext";

const LanguageToggle = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === "hu" ? "en" : "hu");
  };

  return (
    <div
      className="language-toggle-box"
      onClick={toggleLanguage}
      style={{
        backgroundImage: `url(${language === "hu" ? "/img/hero/eng_flag.png" : "/img/hero/hu_flag.png"})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      title={language === "hu" ? "Switch to English" : "Váltás magyarra"}
    >
    </div>
  );
};

export default LanguageToggle;
